import { keyframes } from 'styled-components'

export const textClickAnim = keyframes`
  0%{
    animation-timing-function: cubic-bezier (0.17, 0.17, 0.2, 1);
    opacity:1;

  }
  33%{
    animation-timing-function: cubic-bezier (0.17, -0.33, 0.2, 1);
    opacity:.5;
  }
  100%{
    opacity:1;
  }
`
export const whiteBackgroundAnim = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity: 0;
     }
  33%{
    animation-timing-function: cubic-bezier(1.5,3.6,.2,1);
     opacity: 0.5;
    }
  100%{
     opacity:0;
  } 
`
export const buttonClickScaleAnim = keyframes`
  0%{  
    animation-timing-function: cubic-bezier(.33,1,0,1);
    transform: scale(1);
    }
  50%{
    animation-timing-function: cubic-bezier(0,0,0,1);
    transform: scale(.65);

   }
  100%{
    transform: scale(1); 
    } 
`

export const innerTabAnim = keyframes`
  0% {
    transform: scale(0.5);
    animation-timing-function: cubic-bezier(.33,1,0,1);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`
